import React, { useState, useEffect, useReducer } from 'react'
import {
  Icon,
  IconButton,
  Table,
} from 'rsuite'
import { budgetFormat } from '../../utils/formatterUtil'

export default function OverallBudgetReportTable({
  data,
  ...props
}) {
  const { Column, HeaderCell, Cell } = Table
  
  return (
    <>
        <Table wordWrap autoHeight data={data || []} style={{ marginTop: 10 }} headerHeight={100}>
        <Column width={70} align="center">
          <HeaderCell>ลำดับ</HeaderCell>
          <Cell>
            {(_, index) => {
              return index + 1
            }}
          </Cell>
        </Column>

        <Column width={120} resizable>
          <HeaderCell>ปีงบอนุมัติ</HeaderCell>
          <Cell dataKey="budgetYearApprove" />
        </Column>

        <Column width={150} resizable>
          <HeaderCell>เลขที่โครงการ</HeaderCell>
          <Cell dataKey="projectNo" />
        </Column>

        <Column width={150} resizable>
          <HeaderCell>รหัสโครงการ</HeaderCell>
          <Cell dataKey="projectCode" />
        </Column>

        <Column width={300} resizable>
          <HeaderCell>ชื่อโครงการ</HeaderCell>
          <Cell dataKey="projectName" />
        </Column>

        <Column width={150} resizable>
          <HeaderCell>สำนัก</HeaderCell>
          <Cell dataKey="department" />
        </Column>

        <Column width={200} resizable>
          <HeaderCell>ผู้ประสานงาน (สสส.)</HeaderCell>
          <Cell dataKey="coordinator" />
        </Column>

        <Column width={200} resizable>
          <HeaderCell>รับทุนในนาม</HeaderCell>
          <Cell dataKey="granteeName" />
        </Column>

        <Column width={200} resizable>
          <HeaderCell>องค์กรรับทุน</HeaderCell>
          <Cell dataKey="granteeOrganizationName" />
        </Column>

        <Column width={200} resizable>
          <HeaderCell>ผู้รับผิดชอบโครงการ</HeaderCell>
          <Cell dataKey="responsinatorName" />
        </Column>

        <Column width={120} resizable>
          <HeaderCell>วันเริ่มต้น</HeaderCell>
          <Cell dataKey="startDate" />
        </Column>

        <Column width={120} resizable>
          <HeaderCell>วันสิ้นสุด</HeaderCell>
          <Cell dataKey="endDate" />
        </Column>

        <Column width={150} resizable>
          <HeaderCell>วงเงินอนุมัติ</HeaderCell>
          <Cell style={{ textAlign: 'right' }}>
            {(rowData) => {
              return budgetFormat(rowData.approvedBudget || 0)
            }}
          </Cell>
        </Column>

        <Column width={150} resizable>
          <HeaderCell>สถานะโครงการ</HeaderCell>
          <Cell dataKey="projectStatus" />
        </Column>

        <Column width={180} resizable align='center'>
          <HeaderCell>งวดทั้งหมดของโครงการ</HeaderCell>
          <Cell dataKey="totalPeriods" />
        </Column>

        <Column width={200} resizable>
          <HeaderCell>สถานะย่อยของ new e-fin</HeaderCell>
          <Cell dataKey="eFinSubStatus" />
        </Column>

        <Column width={180} resizable>
          <HeaderCell>วันที่เปลี่ยนสถานะย่อย</HeaderCell>
          <Cell dataKey="statusChangeDate" />
        </Column>

        <Column width={220} resizable>
          <HeaderCell>งวดที่ ณ ปัจจุบันที่ดึงข้อมูล</HeaderCell>
          <Cell dataKey="currentPeriod" />
        </Column>

        <Column width={250} resizable>
          <HeaderCell>รายรับรวม(ตั้งแต่งวด1-งวดปัจจุบัน)</HeaderCell>
          <Cell style={{ textAlign: 'right' }}>
            {(rowData) => {
              return budgetFormat(rowData.totalIncome || 0)
            }}
          </Cell>
        </Column>

        <Column width={300} resizable>
          <HeaderCell>รายได้ดอกเบี้ย(ตั้งแต่งวดที่ 1-งวดปัจจุบัน)ที่บันทึก</HeaderCell>
          <Cell style={{ textAlign: 'right' }}>
            {(rowData) => {
              return budgetFormat(rowData.interestIncome || 0)
            }}
          </Cell>
        </Column>

        <Column width={280} resizable>
          <HeaderCell>รายจ่าย(ตั้งแต่งวดที่ 1-งวดปัจจุบัน)ที่บันทึก</HeaderCell>
          <Cell style={{ textAlign: 'right' }}>
            {(rowData) => {
              return budgetFormat(rowData.totalExpense || 0)
            }}
          </Cell>
        </Column>

        <Column width={150} resizable>
          <HeaderCell>ค่าใช้จ่ายค้างจ่าย</HeaderCell>
          <Cell style={{ textAlign: 'right' }}>
            {(rowData) => {
              return budgetFormat(rowData.pendingExpense || 0)
            }}
          </Cell>
        </Column>

        <Column width={120} resizable>
          <HeaderCell>เงินคงเหลือ</HeaderCell>
          <Cell style={{ textAlign: 'right' }}>
            {(rowData) => {
              return budgetFormat(rowData.remainingBalance || 0)
            }}
          </Cell>
        </Column>

        <Column width={200} resizable>
          <HeaderCell>จำนวนเงินนำฝากคืน สสส.</HeaderCell>
          <Cell style={{ textAlign: 'right' }}>
            {(rowData) => {
              return budgetFormat(rowData.refundAmount || 0)
            }}
          </Cell>
        </Column>

        <Column width={180} resizable>
          <HeaderCell>วันที่นำฝาก/โอนคืน</HeaderCell>
          <Cell dataKey="refundDate" />
        </Column>

        <Column width={120} resizable>
          <HeaderCell>เงินคงเหลือ</HeaderCell>
          <Cell style={{ textAlign: 'right' }}>
            {(rowData) => {
              return budgetFormat(rowData.finalBalance || 0)
            }}
          </Cell>
        </Column>

        <Column width={150} resizable>
          <HeaderCell>หมายเหตุ</HeaderCell>
          <Cell dataKey="remarks" />
        </Column>
        
      </Table>
      </>
  )
}
